<template>
  <div class="flex items-center gap-2">
    <button
      v-if="goal?.has_mentor"
      type="button"
      @click="openBookingModal"
      class="px-3 py-2 text-[12px] font-medium bg-card text-foreground border border-border rounded-full hover:bg-muted flex items-center gap-2"
    >
      <img
        v-if="goal?.mentor?.profile_picture"
        :src="goal.mentor.profile_picture"
        :alt="goal.mentor.name"
        class="w-5 h-5 rounded-full object-cover"
      />
      <div
        v-else
        class="w-5 h-5 rounded-full bg-[#3B82F6] text-white text-[10px] font-semibold flex items-center justify-center"
      >
        {{ getMentorInitials }}
      </div>
      Book a session with {{ goal?.mentor?.name || "mentor" }}
    </button>
    <div class="relative" v-click-outside="closeMenu">
      <button
        type="button"
        @click="toggleMenu"
        class="flex items-center justify-center w-10 h-10 bg-card text-foreground border border-border rounded-full hover:bg-muted"
      >
        <EllipsisVertical class="w-5 h-5 text-muted-foreground" />
      </button>

      <transition name="fade">
        <div
          v-if="showMenu"
          class="absolute right-0 mt-2 w-48 bg-card border border-border rounded-[12px] shadow-lg py-1 z-50 overflow-hidden"
        >
          <button
            @click="handleEdit"
            class="w-full flex items-center gap-2 px-4 py-3 text-[14px] hover:bg-muted transition-colors text-left"
          >
            <Settings class="w-4 h-4" />
            Edit
          </button>
          <button
            @click="handleDelete"
            class="w-full flex items-center gap-2 px-4 py-3 text-[14px] text-red-600 hover:bg-red-50 dark:hover:bg-red-900/10 transition-colors text-left"
          >
            <Trash2 class="w-4 h-4" />
            Delete
          </button>
        </div>
      </transition>
    </div>
    <!-- <div class="relative">
      <button 
        type="button"
        @click.stop="toggleTooltip"
        aria-label="Info"
        class="h-8 w-8 flex items-center justify-center bg-white rounded-[8px] hover:bg-gray-50"
      >
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 10.8V8M8 5.2H8.007M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8Z" stroke="#D0D5DD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>

      <transition name="fade">
        <div 
          v-if="showTooltip"
          v-click-outside="closeTooltip"
          class="absolute top-full right-0 mt-2 w-[280px] rounded-[12px] shadow-lg border border-gray-200 p-4 z-50"
          style="background-color: #F6F8F9;"
        >
          <h3 class="text-[14px] font-semibold text-[#1a1a1a] mb-2">PT DESKTOP</h3>
          <p class="text-[12px] text-[#667085] leading-relaxed mb-3">
            This takes you to the desktop tool to track your learning goal and get real time learning assistance from our AI agents
          </p>
          <div class="flex justify-end">
            <button
              @click="onTrackOnDesktop"
              class="px-3 py-1.5 text-[12px] text-[#222222] font-medium rounded-[8px]"
              style="background-color: rgba(34, 34, 34, 0.08);"
            >
              Read more
            </button>
          </div>
        </div>
      </transition>
    </div> -->
    <!-- <button 
      type="button"
      @click="onTrackOnDesktop"
      class="h-8 px-4 text-[12px] font-medium text-white bg-black rounded-[8px] hover:opacity-90"
    >
      Track on PT desktop
    </button> -->

    <BookSessionModal
      :show="showBookingModal"
      :mentorName="goal?.mentor?.name || 'Mentor'"
      :projectId="projectId"
      @close="closeBookingModal"
      @request-session="handleRequestSession"
    />
  </div>
</template>

<script>
import BookSessionModal from "./BookSessionModal.vue";
import { EllipsisVertical, Settings, Trash2 } from "lucide-vue-next";

export default {
  name: "LearningGoalActionsBar",
  components: {
    BookSessionModal,
    EllipsisVertical,
    Settings,
    Trash2,
  },
  props: {
    goal: {
      type: Object,
      default: null,
    },
    projectId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      showTooltip: false,
      showBookingModal: false,
      showMenu: false,
    };
  },
  computed: {
    getMentorInitials() {
      const name = this.goal?.mentor?.name || "M";
      const parts = name.trim().split(" ");
      if (parts.length >= 2) {
        return (parts[0][0] + parts[1][0]).toUpperCase();
      }
      return name.substring(0, 2).toUpperCase();
    },
  },
  methods: {
    toggleTooltip() {
      this.showTooltip = !this.showTooltip;
    },
    closeTooltip() {
      this.showTooltip = false;
    },
    onTrackOnDesktop() {
      window.open(
        "https://www.edgespace.africa/products/pt-desktop/",
        "_blank",
      );
    },
    openBookingModal() {
      this.showBookingModal = true;
    },
    closeBookingModal() {
      this.showBookingModal = false;
    },
    handleRequestSession(bookingData) {
      this.$emit("book-mentor", bookingData);
      this.closeBookingModal();
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    closeMenu() {
      this.showMenu = false;
    },
    handleEdit() {
      this.closeMenu();
      this.$emit("edit-goal");
    },
    handleDelete() {
      this.closeMenu();
      this.$emit("delete");
    },
  },
  directives: {
    "click-outside": {
      beforeMount(el, binding) {
        el.clickOutsideEvent = function (event) {
          if (!(el === event.target || el.contains(event.target))) {
            binding.value();
          }
        };
        document.addEventListener("click", el.clickOutsideEvent);
      },
      unmounted(el) {
        document.removeEventListener("click", el.clickOutsideEvent);
      },
    },
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
